import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { QcMerchantResponse } from 'src/app/shared/models/qcResponse.model';
import { CouponSet } from '../models/merchant.model';

export const InitColumns = createAction(
  '[Merchant: Summary]: Init Columns',
  props<{
    couponsDisplayedColumns: { [column: string]: string };
    storesDisplayedColumns: { [column: string]: string };
  }>(),
);

export const ViewMerchantInfo = createAction('[Merchant: Summary]: View Merchant Info');

export const SearchMerchant = createAction(
  '[Merchant: Summary]: Search Merchant',
  props<{ element: any }>(),
);

export const SearchMerchantSuccess = createAction(
  '[Merchant: Summary]: Search Merchant Success',
  props<{ res: QcMerchantResponse }>(),
);

export const SearchMerchantFailed = createAction(
  '[Merchant: Summary]: Search Merchant Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CouponsetsPanelStatusChanged = createAction(
  '[Merchant: Summary]: Couponsets Expansion Panel Status Changed',
);

export const StoresPanelStatusChanged = createAction(
  '[Merchant: Summary]: Stores Expansion Panel Status Changed',
);

export const CompanyNameChanged = createAction(
  '[Merchant: Summary]: Company Name Changed',
  props<{ companyName: string }>(),
);

export const WebsiteURLChanged = createAction(
  '[Merchant: Summary]: Website URL Changed',
  props<{ websiteURL: string }>(),
);

export const ActivateMerchant = createAction('[Merchant: Summary]: Activate Merchant');

export const ActivateMerchantSuccess = createAction(
  '[Merchant: Summary]: Activate Merchant Success',
  props<{ res: QcMerchantResponse }>(),
);

export const ActivateMerchantFailed = createAction(
  '[Merchant: Summary]: Activate Merchant Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const DeactivateMerchantModal = createAction(
  '[Merchant: Summary]: Deactivate Merchant Modal',
);

export const DeactivateMerchant = createAction('[Merchant: Summary]: Deactivate Merchant');

export const DeactivateMerchantSuccess = createAction(
  '[Merchant: Summary]: Deactivate Merchant Success',
  props<{ res: QcMerchantResponse }>(),
);

export const DeactivateMerchantFailed = createAction(
  '[Merchant: Summary]: Deactivate Merchant Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const EditCouponset = createAction(
  '[Merchant: Summary]: Edit Couponset',
  props<{ couponSet: CouponSet }>(),
);

export const CloseEditCouponsetSidenav = createAction(
  '[Merchant: Summary]: Close Edit Couponset Sidenav',
);

export const UnbindStoreModal = createAction('[Merchant: Summary]: Unbind Store Modal');

export const UnbindStore = createAction('[Merchant: Summary]: Unbind Store');

export const UnbindStoreSuccess = createAction(
  '[Merchant: Summary]: Unbind Store Success',
  props<{ res: QcMerchantResponse }>(),
);

export const UnbindStoreFailed = createAction(
  '[Merchant: Summary]: Unbind Store Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const DeactivateStoreModal = createAction('[Merchant: Summary]: Deactivate Store Modal');

export const DeactivateStore = createAction(
  '[Merchant: Summary]: Deactivate Store',
  props<{ element: any }>(),
);

export const DeactivateStoreSuccess = createAction(
  '[Merchant: Summary]: Deactivate Store Success',
  props<{ res: QcMerchantResponse }>(),
);

export const DeactivateStoreFailed = createAction(
  '[Merchant: Summary]: Deactivate Store Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ActivateStore = createAction(
  '[Merchant: Summary]: Activate Store',
  props<{ element: any }>(),
);

export const ActivateStoreSuccess = createAction(
  '[Merchant: Summary]: Activate Store Success',
  props<{ res: QcMerchantResponse }>(),
);

export const ActivateStoreFailed = createAction(
  '[Merchant: Summary]: Activate Store Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const StoreFilterChanged = createAction(
  '[Merchant: Summary]: Store Filter Changed',
  props<{ storesFilter: string }>(),
);
